import React from 'react';
import { WhatsAppOutlined } from '@ant-design/icons';

const WhatsAppButton = () => (
  <a
    href="https://wa.me/221787362727"
    target="_blank"
    rel="noopener noreferrer"
    className="whatsapp-float"
    title="Contactez-nous sur WhatsApp"
  >
    <WhatsAppOutlined />
  </a>
);

export default WhatsAppButton;
